import { flattenColumns } from '../../utils/orderedCell';
import {
  columnIndexByCode,
  hasMultiFilterSelection,
  rowMatchesMultiFilter,
  stringCellValue,
} from '../../utils/tableHeaderSubMenuMultiFilter';
import { DataDai } from './types';

const AVERAGE_ROW_LABEL = '平均/合計';

/**
 * タイプ列の複数選択。数値フィルターと同じく、先頭セルが「平均/合計」の行は残す。
 */
export const dataDaiRowsFilteredByMultiFilter = (
  columns: DataDai['data']['columns'],
  rows: DataDai['data']['rows'],
  selectedByColumn: { [columnName: string]: string[] } | undefined
): DataDai['data']['rows'] => {
  if (!hasMultiFilterSelection(selectedByColumn)) {
    return rows;
  }
  const columnIndexMap = columnIndexByCode(flattenColumns(columns));
  return rows.filter(
    (row) =>
      row.data.at(0)?.value === AVERAGE_ROW_LABEL ||
      rowMatchesMultiFilter(row, selectedByColumn, (target, columnCode) =>
        stringCellValue(columnIndexMap, target, columnCode)
      )
  );
};
